export const bulkUpdate = (param, val, bulk) => {
    if (!param) {
        return bulk;
    }
    let ret = param.set(val, true, true);
    if (ret) {
        let {id, value} = ret;
        bulk[id] = value;
    } else {
        bulk[param.id] = val;
    }
    return bulk;
}
